import { Badge, Eyebrow } from "@pej/kore/components";
import { ChevronRight, Clock } from "lucide-react";
import type { SelectorWorkspace } from "@/contexts/workspace-derivation";

interface WorkspaceRowProps {
    workspace: SelectorWorkspace;
    isRecent: boolean;
    onSelect: (id: string) => void;
}

export function WorkspaceRow({ workspace, isRecent, onSelect }: WorkspaceRowProps) {
    return (
        <button
            type="button"
            onClick={() => onSelect(workspace.id)}
            className="grid w-full grid-cols-[minmax(0,1fr)_auto_auto] items-center gap-3 border-t border-border/60 px-4 py-3 text-left first:border-t-0 hover:bg-muted/40 focus-visible:border-ring focus-visible:outline-none focus-visible:ring-3 focus-visible:ring-ring/50"
            aria-label={`Open workspace ${workspace.name}`}
        >
            <div className="flex items-center gap-2">
                <span className="text-sm font-semibold text-foreground">{workspace.name}</span>
                {isRecent && (
                    <Badge className="bg-primary/10 text-primary text-[9.5px] font-bold uppercase tracking-wider">
                        <Clock className="size-2.5" />
                        Recent
                    </Badge>
                )}
            </div>
            <Eyebrow>{workspace.role}</Eyebrow>
            <ChevronRight className="size-3.5 text-muted-foreground" />
        </button>
    );
}
